import { gql } from '@apollo/client';

export const CONTRACTORS = gql`
  query Contractors($search: String) {
    contractors(search: $search) {
      id
      name
      phone
      email
      description
      availableArea {
        states
        counties
      }
      createdAt
      updatedAt
    }
  }
`;

export const CONTRACTOR = gql`
  query Contractor($id: ID!) {
    contractor(id: $id) {
      id
      ownerUserId
      name
      phone
      email
      description
      availableArea {
        states
        counties
      }
      createdAt
      updatedAt
      members {
        id
        name
        email
      }
    }
  }
`;

export const MY_CONTRACTOR = gql`
  query MyContractor {
    myContractor {
      id
      ownerUserId
      name
      phone
      email
      description
      availableArea {
        states
        counties
      }
      createdAt
      updatedAt
      members {
        id
        name
        email
      }
    }
  }
`;
